import React from 'react';
import { InputTextArea, useReadOnly } from '@spark';
import CopyFieldButton from './CopyFieldButton';
import FieldLabelWithHelp from './FieldLabelWithHelp';

const defaultHelpText = `Optional system prompt sent to the teacher model as the system message of every request (playground, data generation and teacher evaluation).
For generative tasks, the student model inherits it for training & evaluation unless overridden in the Student Model section.`;

/**
 * System prompt editor, shown for all task types. Persisted on the usecase
 * as `teacher_system_prompt`.
 */
const SystemPromptInput = ({
    value,
    onChange,
    role,
    labelText = 'System prompt',
    helpText = defaultHelpText,
    rows = 3,
}) => {
    const { readOnly } = useReadOnly();
    return (
        <div>
            <FieldLabelWithHelp
                label={labelText}
                helpText={helpText}
                style={{ marginBottom: 8 }}
            />
            <div style={{ position: 'relative' }}>
                <CopyFieldButton value={value} />
                <InputTextArea
                    showLabel={false}
                    placeholder="e.g. You are a helpful assistant that writes concise, factual responses."
                    value={value || ''}
                    onChange={onChange}
                    stretch
                    rows={rows}
                    disabled={readOnly || role === 'Viewer'}
                    style={{ maxWidth: '100%' }}
                />
            </div>
        </div>
    );
};

export default SystemPromptInput;
